module.exports = __webpack_public_path__ + "static/media/iPadLandscape.310dfb6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/iPadLandscape.png
// module id = 121
// module chunks = 0